import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CollapsibleService {

	constructor() { }

	setCollapsible(elId){
		let el = document.getElementById(elId);

		let isCollapsed = el.classList.contains('collapsed');
		if(isCollapsed){
			el.classList.replace("collapsed", "expanded");
			this.changeBtnText(el, 'See Less');
		} else {
			el.classList.replace("expanded", "collapsed");
			this.changeBtnText(el, 'See More');
		}
	}

	changeBtnText(el:any, text){
		el.childNodes.forEach(element => {
			let childEl:any =  element;
			if(typeof childEl.classList != 'undefined'){
				let isBtnCtrl = element.classList.contains('collapse-control');
				if(isBtnCtrl){
					element.innerHTML = text;
				}
			}
		});
	}
}
